const InstagramIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_23604_31613)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.795 4.43533C16.6836 1.97075 14.6436 0 12.1521 0H5.44755L5.23513 0.00479187C2.77055 0.1162 0.799805 2.15616 0.799805 4.64775V11.3523L0.804597 11.5647C0.916005 14.0293 2.95596 16 5.44755 16H12.1521L12.3645 15.9952C14.8291 15.8838 16.7998 13.8438 16.7998 11.3523V4.64775L16.795 4.43533ZM5.44755 1.5H12.1521L12.3303 1.505C13.9822 1.59786 15.2998 2.9732 15.2998 4.64775V11.3523L15.2948 11.5305C15.2019 13.1824 13.8266 14.5 12.1521 14.5H5.44755L5.26933 14.495C3.61741 14.4021 2.2998 13.0268 2.2998 11.3523V4.64775L2.3048 4.46952C2.39766 2.8176 3.77301 1.5 5.44755 1.5ZM13.1123 8C13.1123 5.62206 11.1777 3.6875 8.7998 3.6875C6.42187 3.6875 4.4873 5.62206 4.4873 8C4.4873 10.3779 6.42187 12.3125 8.7998 12.3125C11.1777 12.3125 13.1123 10.3779 13.1123 8ZM5.9873 8C5.9873 6.45049 7.25029 5.1875 8.7998 5.1875C10.3493 5.1875 11.6123 6.45049 11.6123 8C11.6123 9.54951 10.3493 10.8125 8.7998 10.8125C7.25029 10.8125 5.9873 9.54951 5.9873 8ZM14.0498 3.75C14.0498 4.16421 13.714 4.5 13.2998 4.5C12.8856 4.5 12.5498 4.16421 12.5498 3.75C12.5498 3.33579 12.8856 3 13.2998 3C13.714 3 14.0498 3.33579 14.0498 3.75Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_23604_31613">
        <rect width="16" height="16" fill="currentColor" transform="translate(0.799805)" />
      </clipPath>
    </defs>
  </svg>
);

export { InstagramIcon };
